import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';

@Component({
  name: 'CheckBoxComponent'
})
class CheckBoxComponent extends TombolaBaseComponent {
  @Prop() public name: string;
  @Prop() public inputValue: string;
  @Prop() public value: boolean;
  @Prop() public id: string;
  @Prop() public disabled: boolean;

  private get inputId(): string {
    return this.id || `checkbox_${this._uid.toString()}`;
  }

  private get checkedState(): boolean {
    return this.value;
  }

  private set checkedState(value: boolean) {
    this.$emit('input', value);
  }
}

export default CheckBoxComponent;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/shared-components/check-box/check-box.component.ts